import { State } from "../config/state.model";
import { IState } from "../interfaces/config/state.model.interface";
import { IProductCategory } from "../interfaces/product/product-category.model.interface";
import { IZone } from "../interfaces/zone/zone.model.interface";
import { IZoneContentSet } from "../interfaces/zone/zone-content-set.model.interface";
import { IContentType } from "../interfaces/content/content-type-model.interface";
import { IProperty } from "../interfaces/property/property.model.interface";
import { Property } from "../property/property.model";

export class Zone implements IZone {
    public zoneId: number;
    public code: string;
    public name: string;
    public description: string;
    public urlPattern: string;
    public allowConquest: boolean;
    public allowMultivariate: boolean;
    public createdDate: Date;
    public state: IState;
    public property: IProperty;
    public contentSets: IZoneContentSet[];
    public contentTypes: IContentType[];
    public permittedCategories: IProductCategory[];

    constructor() {
        this.zoneId = 0;
        this.code = "";
        this.name = "";
        this.description = "";
        this.urlPattern = "";
        this.allowConquest = true;
        this.allowMultivariate = true;
        this.createdDate = new Date();
        this.state = new State();
        this.property = new Property();
        this.contentSets = [];
        this.contentTypes = [];
        this.permittedCategories = [];
    }
}
